import React, { useReducer, useEffect, useMemo, ReactNode } from 'react';
import {
  initialState,
  settingsReducer,
  SettingsContext,
} from './SettingsContextUtils';

interface SettingsProviderProps {
  children: ReactNode;
}

export const SettingsProvider: React.FC<SettingsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(settingsReducer, undefined, initialState);

  useEffect(() => {
    localStorage.setItem('locale', state.locale);
  }, [state.locale]);

  const contextValue = useMemo(() => ({ state, dispatch }), [state]);

  return (
    <SettingsContext.Provider value={contextValue}>
      {children}
    </SettingsContext.Provider>
  );
};

